"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentUrlUploadProcessor", {
    enumerable: true,
    get: function() {
        return AttachmentUrlUploadProcessor;
    }
});
const _common = require("@nestjs/common");
const _dataattachmentv3service = require("~/services/v3/data-attachment-v3.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let AttachmentUrlUploadProcessor = class AttachmentUrlUploadProcessor {
    async job(job) {
        await this.dataAttachmentV3Service.handleUrlUploadCellUpdate(job.data);
    }
    constructor(dataAttachmentV3Service){
        this.dataAttachmentV3Service = dataAttachmentV3Service;
    }
};
AttachmentUrlUploadProcessor = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _dataattachmentv3service.DataAttachmentV3Service === "undefined" ? Object : _dataattachmentv3service.DataAttachmentV3Service
    ])
], AttachmentUrlUploadProcessor);
